import IconButton from '@mui/material/IconButton'
import DarkModeIcon from '@mui/icons-material/DarkModeRounded'
import LightModeIcon from '@mui/icons-material/LightModeRounded'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import { useAppState } from 'hooks'
import Tooltip from 'components/Tooltip'

function ColorModeSwitcher() {
  const { t } = useTranslation()
  const { colorMode, setColorMode } = useAppState()

  const nextColorMode = colorMode === 'dark' ? 'light' : 'dark'

  return (
    <Tooltip title={t(`colorMode.${nextColorMode}`)}>
      <IconButton
        size="small"
        color="primary"
        onClick={() => {
          setColorMode(nextColorMode)
        }}
      >
        {colorMode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  )
}

export default ColorModeSwitcher
